import React from "react";

export default function CardLayout({background, header, children, showCardStyle = true}) {
    const mainStyle = {
        width: "90%",
        margin: "auto"
    };

    const cardStyle = showCardStyle
    ? {
        backgroundColor: background || "white",
        shadowColor: "rgba(0,0,0,0.2)",
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.8,
        shadowRadius: 8,
        borderRadius: 20,
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)"
    }
    : {};

    return (
        <div style={mainStyle}>
            <div
                style={{
                    fontSize: "23px",
                    fontWeight: "bold",
                    textAlign: "end",
                    margin: "10px"
                }}
            >
                {header}
            </div>

            <div style={cardStyle}>{children}</div>
        </div>
    );
}
